import React, { type FC, useState, useEffect } from 'react';

import { Container, Content, Header, Title, Text, CloseButton } from './styles';
import useGetCheckins from '@/hooks/useGetCheckins';
import { CheckinStatus } from '@/types/checkin';

export const PartnerCheckinGuideModal: FC = () => {
  const { checkins: todayCheckins, loading: loadingTodayCheckins } =
    useGetCheckins(
      [
        CheckinStatus.AWAITING_CONFIRMATION,
        CheckinStatus.PENDING,
        CheckinStatus.CONFIRMED,
      ],
      'all',
      true
    );
  const { checkins: allCheckins, loading: loadingAllCheckins } = useGetCheckins(
    [
      CheckinStatus.AWAITING_CONFIRMATION,
      CheckinStatus.PENDING,
      CheckinStatus.CONFIRMED,
      CheckinStatus.DONE,
      CheckinStatus.CANCELED,
      CheckinStatus.EXPIRED,
    ],
    'all',
    false
  );

  const isLoading = loadingTodayCheckins || loadingAllCheckins;

  const [dismissed, setDismissed] = useState(false);
  const [open, setOpen] = useState(false);

  const shouldShowReminderModal =
    !isLoading && todayCheckins.length >= 1 && allCheckins.length <= 10;

  useEffect(() => {
    if (shouldShowReminderModal && !dismissed) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [shouldShowReminderModal, dismissed]);

  const handleClose = () => {
    setDismissed(true);
    setOpen(false);
  };

  if (!open || isLoading || !shouldShowReminderModal) return null;

  const mostRecentTodayCheckin = todayCheckins.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];

  return (
    <Container>
      <Content>
        <Header>
          <Title>Lembre de pedir para o usuário iniciar o checkin.</Title>
        </Header>
        {mostRecentTodayCheckin && (
          <Text>{mostRecentTodayCheckin.user.name}</Text>
        )}
        <Text>
          Lembre de, quando o usuário chegar ao estabelecimento, pedir para ele
          abrir o app, a página de reserva e clicar no botão de iniciar treino,
          para contabilizar seu check-in.
        </Text>
        <CloseButton type="button" onClick={handleClose}>
          Entendi
        </CloseButton>
      </Content>
    </Container>
  );
};

export default PartnerCheckinGuideModal;